module.exports = __webpack_public_path__ + "static/media/Constellations_webp_border.377309f7.webp";